import { useEffect } from "react";

import Testimonios from "../molecules/Testimonios";
import Descubri from "../molecules/Descubri";

import top from "../../images/plataforma/top-nuestra-plataforma.png";
import headOldLady from "../../images/plataforma/head-old-lady.jpeg";
import web from "../../images/plataforma/desktop-home-1.png";
import mobile from "../../images/plataforma/mobile-home.png";
import smartwatch from "../../images/plataforma/sw-home.png";

import "./NuestraPlataforma.css";
import Contacto from "../molecules/Contacto";

export const NuestraPlataforma = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <img
        src={headOldLady}
        alt="Old Lady"
        style={{ width: "100%", margin: "0 auto" }}
      />

      <div id="nuestra-plataforma">
        <div className="nuestra-plataforma-container">
          <img
            className="nuestra-plataforma-image-top"
            src={top}
            alt="Top Porpósito"
          />
        </div>

        <div className="nuestra-plataforma-container">
          <div className="nuestra-plataforma-titles">
            <h1>Nuestra Plataforma</h1>
            <sub>
              Una plataforma simple y eficiente que consta de 3 elementos y que
              permite setear tu propio esquema de ayuda y asistencia
            </sub>
          </div>
        </div>

        <div className="nuestra-plataforma-container">
          <div
            className="nuestra-plataforma-box-image"
            style={{ display: "flex" }}
          >
            <img
              className="nuestra-plataforma-image"
              src={web}
              alt="Illustration of the Web Portal"
              style={{ width: "60%" }}
            />
          </div>
          <div className="nuestra-plataforma-box">
            <h1>Portal Web</h1>
            <p style={{ textAlign: "justify" }}>
              Accede a nuestra Web en www.ellie.care para consultar o modificar
              tus datos personales, consultar y contratar online nuestros
              productos y servicios, setear tu red de ayuda, consultar tu saldo
              de Ellie Coins y lo que podés hacer con ellos, o entrar en nuestro
              Ellie Club para conectarte con otra gente cerca de tu casa.
            </p>
          </div>
        </div>

        <div className="nuestra-plataforma-container">
          <div
            className="nuestra-plataforma-box-image"
            style={{ display: "flex" }}
          >
            <img
              className="nuestra-plataforma-image"
              src={mobile}
              alt="Illustration of the Web Portal"
              style={{ width: "20%" }}
            />
          </div>
          <div className="nuestra-plataforma-box">
            <h1>Ellie Care Go para tu celular</h1>
            <p style={{ textAlign: "justify" }}>
              A través de nuestra app Ellie GO en tu celular también podes
              setear tu red de ayuda, invitando a tus contactos de confianza,
              completar tu información personal, y hasta incluso también pedir
              asistencia a través del Botón de Ayuda.
            </p>
          </div>
        </div>

        <div className="nuestra-plataforma-container">
          <div
            className="nuestra-plataforma-box-image"
            style={{ display: "flex" }}
          >
            <img
              className="nuestra-plataforma-image"
              src={smartwatch}
              alt="Illustration of the Web Portal"
              style={{ width: "30%" }}
            />
          </div>
          <div className="nuestra-plataforma-box">
            <h1>Ellie Care Go para tu SmartWatch</h1>
            <p style={{ textAlign: "justify" }}>
              <b>
                Es importante que uses el SmartWatch para que tu experiencia sea
                todavía mejor.
              </b>{" "}
              Podes comprar tu SmartWatch Samsung Ellie Care junto con la
              suscripción al Plan Gold, o pedirlo en comodato suscribiendo al
              Plan Gold Comodato. En ambos casos vas a recibir tu reloj ya
              configurado y listo para usar. Estético, fácil de usar, fácil de
              cargar, ¡solo tienes que usarlo y nosotros te cuidamos!
            </p>
          </div>
        </div>
        <Testimonios />
        <Descubri />
        <Contacto/>
      </div>
    </>
  );
}

export default NuestraPlataforma;
